<template>
  <div class="pageHeader">
    <div class="navBox" v-if="title">
      <van-nav-bar
        :title="title"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    title() {
      return this.$route.meta.title || "";
    },
  },
  created() {},
  destroyed(){
    this.$bus.$off("handleBack",()=>{})
  },
  methods: {
    onClickLeft() {
      this.$bus.$emit("handleBack",{})
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss">
.pageHeader {
  box-shadow: 0px 0px 10px 0px rgb(215, 215, 221);
  margin-bottom: 10px;
  background: #fff;
  .navBox {
    padding: 0;
    .van-nav-bar__title {
      font-size: 14px !important;
      color:#000;
      // font-weight: bold;
    }
  }
}
</style>